"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorScreen = require("./ErrorScreen");
Object.keys(_ErrorScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorScreen[key];
    }
  });
});